<template>
    <item-edit-view v-slot:default="_">
        <cashbox-edit-form
                :disabled="_.itemDisabled"
                v-model="_.item"
        />
    </item-edit-view>
</template>

<script>
    import ItemEditView from '../../Item/Views/ItemEditView'
    import CashboxEditForm from './Shared/CashboxEditForm'

    export default {
        name: 'CashboxesEditPage',
        components: {
            ItemEditView,
            CashboxEditForm,
        },
    }
</script>
